import { useEffect } from "react";

export function useAuditHistoryLoader(vm, enabled) {
  useEffect(() => {
    if (enabled) vm.getAudits();
  }, [enabled, vm.getAudits]);
}
